<template>
  <div>
        <banner>
            <div class="huoyuanxx">
                <div style="font-size:36px;">货源信息</div>
                <div style="margin-top:18px;font-size:18px;line-height:28px;">了解这个行业改变游戏规则的平台如何使托运人和货运代理商能够主动创建和优化可执行的运输计划，<br />
以及将订单或特定订单类型直接发送到特定的承运商。</div>
            </div>
        </banner>
        <div class="shissjbg">
          <div class="shidata">
            <div class="sstit">
                <img src="@/assets/sjtit.png" width="20" height="20" />
                <span>实时数据</span>
            </div>
            <div class="listitem" v-for="(n,i) in list" :key="i">
                <img src="@/assets/list-c.png" width="36" height="36" />
                <div style="width:170px;margin:0 20px 0 40px;" class="chaocyc">{{n.sendAddressName}}</div>
                <img src="@/assets/jiant.png" width="36" height="6" />
                <div style="width:170px;margin:0 100px 0 20px;" class="chaocyc">{{n.receiveAddressName}}</div>
                <img src="@/assets/time.png" width="18" height="18" />
                <div style="width:80px;margin-left:10px;">白天</div>
                <div style="width:170px;margin-left:40px;" class="chaocyc">{{n.quantity}}吨/{{n.goodsType}}</div>
                <div style="width:170px;margin-left:40px;" class="chaocyc">2000元/吨公里价格</div>
                <div style="width:170px;margin-left:40px;" class="chaocyc">巨力索具股份有限公司配货</div>
            </div>
            <div v-if="isMore" class="nodata">暂无数据</div>
            <el-pagination
                style="margin:50px 0;text-align:center;"
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[5, 10, 15, 20]"
                :page-size="5"
                layout="total, sizes, prev, pager, next, jumper"
                :hide-on-single-page="total < 6"
                :total="total">
                </el-pagination>
            <div class="fahuo" @click="fahuochang">
                <img src="@/assets/fahuo.png" width="28" height="28" />
                <span>我要发货</span>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
import Banner from '../components/banner/banner'
import { notDoneOrder } from '@/utils/service'
import { wtUrl } from '@/utils/confing'
export default {
    data(){
        return {
            //currentPage4:1
            //pageNo:1,
            list:[],
            total:0,
            pageSize:5,
            isMore:false
        }
    },
    components:{
        Banner
    },
    created(){
        this.gethylist(1)
    },
    methods:{
        setLoca(){
            localStorage.setItem('infor',{
                name:'张三'
            })
        },
        delteLoca(){
            localStorage.removeItem('infor')
        },
        //改变pagesize
        handleSizeChange(val){
            this.pageSize = val
            this.gethylist(1)
        },
        //改变pageNum
        handleCurrentChange(val){
            this.gethylist(val)
        },
        gethylist(pageNo){
            notDoneOrder({
                pageNo,
                pageSize:this.pageSize
            }).then(rps =>{
                if(rps.records.length > 0){
                    this.list = rps.records
                }else{
                    this.list = []
                }
                if(rps.total == 0){
                    this.isMore = true
                }
                this.total = rps.total*1
                
                // if(rps.pages == 0){
                //     this.isMore = true
                //     //this.more = '暂无数据'
                // }
            })
        },
        fahuochang(){
            location.href = wtUrl
        }
    }
}
</script>

<style>
    .el-pagination.is-background .el-pager li:not(.disabled).active{ background-color:#ED9C0D }
</style>

<style lang="stylus" scoped>
    .huoyuanxx
        padding-top: 80px
        color: #fff
    .shissjbg
        background: #eef6ff
        padding: 50px 0
        .shidata
            width: 1400px
            margin: 0 auto
            padding: 40px
            background: #fff
            .sstit
                display:-webkit-box
                display: -webkit-flex
                display: flex
                align-items:center 
                justify-content:center
                font-size: 16px
                color: #08599A
                font-weight: bold
                span
                    margin-left: 10px
            .listitem
                display:-webkit-box
                display: -webkit-flex
                display: flex
                height: 90px
                line-height: 90px
                align-items:center 
                border-bottom: 1px solid #ccc
            .more
                margin-top: 30px
                text-align: center
                color: #aeacac
        .fahuo
            display:-webkit-box
            display: -webkit-flex
            display: flex
            width: 180px
            height: 55px
            margin:  0 auto
            align-items: center
            justify-content: center
            background: #ED9C0D
            font-size: 16px
            color: #fff
            cursor:pointer
            span
                margin-left: 10px
    .chaocyc
        text-overflow: ellipsis
        white-space: nowrap
        overflow: hidden
    .nodata
        width: 100%
        margin: 100px 0
        text-align: center
        font-size: 20px
</style>